import './Departures.scss';

import DeparturesHeader from "./components/DeparturesHeader/DeparturesHeader";
import DeparturesContent from "./components/DeparturesContent/DeparturesContent";

const Departures = () => {

    return (
        <div className={"departures"}>
            <div className={"departures_container"}>
                <div className={"departures_header"}>
                    <DeparturesHeader/>
                </div>
                <div className={"departures_content"}>
                    <DeparturesContent/>
                </div>
            </div>
        </div>
    )
}

export default Departures;